var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneProfessionalHotline } from '@/actions/ProfessionalHotlineActions';
import { useHotlineProDetailDataContext } from '@/feature/hotline/professional/detail/context/HotlineProDetailDataContext';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * コンサルホットライン（コンサル側）詳細データを取得するカスタムフック
 */
export const useHotlineProDetailFetch = (options) => {
    const { dispatch, id, onError, onSuccess, unmountRef } = options;
    const { detailData, setDetailData } = useHotlineProDetailDataContext();
    /**
     * データ取得
     */
    const fetchDetailDataBase = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { payload } = yield wrapDispatch(dispatch, apiGetOneProfessionalHotline({
                path: { id },
            }, {}));
            if (!unmountRef.current) {
                // 取得したデータを context 内に保存
                setDetailData({
                    [payload.id]: payload,
                });
                yield (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(payload));
            }
        }
        catch (e) {
            if (!unmountRef.current) {
                return;
            }
            yield (onError === null || onError === void 0 ? void 0 : onError(e));
            throw e;
        }
    }), [dispatch, id, onError, onSuccess, setDetailData, unmountRef]);
    // ローディング制御
    const { callbackPromiseEvent: fetchDetailData, doing: isLoading } = usePromiseDoingCallback({
        initialDoingState: true,
        promiseEvent: fetchDetailDataBase,
        unmountRef,
    });
    return {
        detailData,
        fetchDetailData,
        isLoading,
        setDetailData,
    };
};
